// First, define the type for better TypeScript support
export type ThemeColors = {
  background: string;
  text: string;
  button: string;
};

// Map colors to your theme structure
export const getThemeByColor = (
  color: 'Blue' | 'Red' | 'Orange' | 'Green',
): ThemeColors => {
  const colorMap: Record<string, ThemeColors> = {
    Blue: {
      background: 'bg-[#F5FAFF]',
      text: 'text-[#2087FF]',
      button: 'bg-[#2087FF]',
    },
    Red: {
      background: 'bg-[#FFFBFA]',
      text: 'text-[#D92D20]',
      button: 'bg-[#D92D20]',
    },
    Orange: {
      background: 'bg-[#FFFCF5]',
      text: 'text-[#DC6803]',
      button: 'bg-[#DC6803]',
    },
    Green: {
      background: 'bg-[#FAFDF7]',
      text: 'text-[#518A15]',
      button: 'bg-[#518A15]',
    },
  };

  return colorMap[color] || DEFAULT_THEME;
};

// Default theme as fallback
export const DEFAULT_THEME: ThemeColors = {
  background: 'bg-[#F5FAFF]',
  text: 'text-[#2087FF]',
  button: 'bg-[#2087FF]',
};

const ICON_MAP = [
  //'icon-name', // icon code
  'icon-nameStore', // 0
  'icon-nameBuy', // 1
  'icon-nameWallet-income', // 2
  'icon-menu', // 3
  'icon-nameCheck-circle', // 4
  'icon-nameWallet-income', // 5
  'icon-Report-List', // 6
  'icon-nameDocument-verified', // 7
  'icon-nameReceipt-bill-2', // 8
  'icon-namedollardayerei', // 9
  'icon-nameStore', // 10
  'icon-Validation', // 11
];

export const IconCodeToIconString = (code: number | null): string => {
  if (code !== null && code !== undefined && ICON_MAP[code]) {
    return ICON_MAP[code];
  }
  return ICON_MAP[0];
};
